import useVersionInfo from 'hooks/useVersionInfo';
import { isV4Release } from 'utilities/constants/versions';

export const useIsShowingV4 = () => {
  const { ver } = useVersionInfo();
  return isV4Release(ver);
};
